<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="css"
    :viewBox="viewbox"
    v-html="svgContent"
  ></svg>
</template>

<script>
import { ref } from 'vue';
const folder = import.meta.glob('/public/assets/images/svg/*.svg', {as: 'raw', eager: true,});

export default {
  name: "SVG",
  components: {
  },
  setup() {
    return {
      svgContent: ref(''),
      viewbox: ref(''),
    };
  },
  props: {
    name: {
      type: String,
      required: true
    },
    css: {
      type: String,
      default: ""
    },
  },
  async beforeMount() {
    if (!this.name && !folder.hasOwnProperty(`/public/assets/images/svg/${this.name}.svg`)) {
      console.error(`SVG file "${this.name}" not found.`);
      return;
    }

    let svg = folder[`/public/assets/images/svg/${this.name}.svg`];
    this.viewbox = svg.match(/viewBox="([^"]*)"/)[1];

    svg = svg.replace(/<\?xml[^>]*>/, '');
    svg = svg.replace(/<!DOCTYPE[^>]*>/, '');
    svg = svg.replace(/<\!--[^>]*-->/, '');
    svg = svg.replace(/<svg[^>]*>/, '');

    this.svgContent = svg;
  },

};
</script>
